import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { Grid, ListItemIcon, ListSubheader } from '@mui/material'
import DeleteBattery from './DeleteBattery'
import EditBattery from './EditBattery'
import BatteryIcon from '@mui/icons-material/BatteryCharging80'
import { JSONSchema7 } from 'json-schema'
import { Battery } from '../../interfaces/battery'
import CreateBattery from './CreateBattery'
import schema from '../../schemas/battery.json'

export interface Props {
  disabled: boolean
  data: Battery[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function BatteryList({ disabled, data, setData }: Props) {
  return (
    <List
      dense
      subheader={
        <ListSubheader>
          <Grid container alignItems={'center'}>
            {'Batteries'}
            <CreateBattery disabled={disabled} data={data} schema={schema as JSONSchema7} setData={setData} />
          </Grid>
        </ListSubheader>
      }
    >
      {data.map((obj: Battery, index: number) => {
        return (
          <ListItem
            key={index}
            secondaryAction={
              <>
                <EditBattery disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
                <DeleteBattery disabled={disabled} value={obj} setData={setData} />
              </>
            }
            disablePadding
          >
            <ListItemButton disabled={disabled}>
              <ListItemIcon>
                <BatteryIcon />
              </ListItemIcon>
              <ListItemText
                primary={obj.name}
                secondary={`capacity: ${obj.max_phys_storage / 1000} kWh | power: ${obj.max_power / 1000} kW `}
                sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
